/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:00:52
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-07-19, 13:47:47
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import { Form } from "antd";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { traits } from 'traits-decorator';
import { bindActionCreators } from 'redux';
import TFormCreate from 'traits/formCreate';
import { hashHistory } from 'react-router';
import { loginUser } from "actions/authorization";

import './style.sass';
import template from './template';

/**
 * Component class.
 *
 * @class Login
 * @extends {React.Component}
 */
@connect(
  state => ({}), 
  dispatch => bindActionCreators({ loginUser }, dispatch)
)
@traits(TFormCreate) 
class Login extends React.Component {

  /**
   * Main state of component.
   * 
   * @memberof Login
   */
  state = {
    loading: false,
    message: null,
    messageSuccessText: 'Poprawne logowanie. Za chwilę nastąpi przekierowanie.',
    messageErrorText: 'Błędne logowanie. Niepoprawny e-mail lub hasło. Prosimy spróbować ponownie za chwilę.'
  }

  /**
   * Validation prototypes.
   * 
   * @static
   * @memberof Login
   */
  static propTypes = {
    form: PropTypes.object.isRequired,
    loginUser: PropTypes.func.isRequired,
    redirect: PropTypes.object.isRequired
  }

  /**
   * Add new row in list.
   * 
   * @param {any} [event={}] 
   * @memberof Login
   */
  loginUserToPlatform = (event = {}) => {
    event.preventDefault();
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        this.toogleLodingSpinner(true);
        this.props.loginUser(values)
          .then(() => this.resolveSuccessResponseFromForm(() => {
            hashHistory.push('/clients');
          }))
          .catch(() => this.resolveErrorResponseFromForm())
      }
    });
  }

  /**
   * Main rendering function.
   *
   * @memberof Login
   */
  render = () => template(this);
}

export default Form.create()(Login);


// WEBPACK FOOTER //
// ./src/rcapp/components/authorization/login/index.js